export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (error) {
    return undefined
  }
}

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (error) {
    // Ignore write errors.
  }
}

/** 清除持久化的 state（退出登录时调用，避免下次进入仍恢复旧 token） */
export const clearState = () => {
  try {
    localStorage.removeItem('state')
  } catch (error) {
    // Ignore
  }
}
